<template>
  <div
    v-if="facebookAppId"
    :class="{ mastery: mastery }"
    class="facebook-component-container"
    @click="authenticate()"
  >
    <icon
      v-if="mastery"
      :name="'facebook-f'"
    />
  </div>
</template>

<script>
import Authentication from '@/mixins/authentication';
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  mixins: [Authentication],
  props: {
    createAccount: {
      type: Boolean,
      default: false,
    },
    mastery: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    facebookAppId() {
      return this.$store.getters['app/facebookAppId'];
    },
  },
  methods: {
    authenticate() {
      // FB may not have loaded yet
      if (typeof(FB) === 'undefined' || FB === null) return;
      const trackingParams = this.collectTrackingParams();
      FB.login((response) => {
        if (response.status === 'connected' && response.authResponse.accessToken) {
          this.loading = true;
          this.$store.dispatch('session/signIn', [{ accessToken: response.authResponse.accessToken, ...trackingParams }]).then(response => {
            if (this.$store.getters['session/currentUser'].newFromFacebook) {
              this.$analytics.events.signUp(this.$store, 'Facebook');
              this.postSignUp();
            } else {
              this.redirectAfterSignIn();
            }

            this.$notify({
              group: 'notifications',
              text: 'You are now logged in',
              type: 'success',
            });
          }).catch(e => {
            this.errorNotification();
            this.loading = false;
          });
        } else {
          this.errorNotification();
        }
      }, { scope: 'email' });
    },
    errorNotification() {
      this.$notify({
        group: 'notifications',
        text: 'Facebook Authentication Failed',
        type: 'error',
      });
    },
  },
};
</script>
<style lang='scss' scoped>
  .facebook-component-container {
    background-color: #3b5998;
    box-sizing: border-box;
    color: white;
    cursor: pointer;

    &.mastery {
      border-radius: var(--radius-full);
      display: grid;
      place-content: center;
      height: 44px;
      width: 44px;

      img {
        height: rem-calc(20);
        width: rem-calc(20);
      }
    }
  }
</style>
